import { useMutation } from 'react-query';

import { unshareProject } from 'shared/api/projects/http';

const useMutateUnshareProject = (options = undefined) =>
  useMutation(({ id, userId }) => unshareProject(id, userId), options);

export default useMutateUnshareProject;
